<template>
  <div id="modalTemplate" class="modal-dialog myDialogM" v-if="showDialog">
    <div class="modalHeader">
      <span class="title">Template Editor</span>
      <span @click="closeModal" class="btn-close float-right"><i class="fas fa-times"></i></span>
    </div>

    <div class="modalBody">
      <div>
        <div class="form-group">
          <label for="templateSelect">Template</label>
          <select class="form-control form-control-sm" id="templateSelect" v-model="currentTemplateName" @change="changeTemplate">
            <option v-for="(template, index) in $store.state.templates" :key="index">
              {{ template.name }}
            </option>
          </select>
        </div>
      </div>

      <hr />

      <v-client-table v-if="Object.keys($store.state.templates[$store.state.currentTemplateName]).length" :data="$store.getters.templateFields()" :columns="columns" :options="options">
        <template slot="page" slot-scope="props">
          {{ props.row.page }}
        </template>

        <template slot="id" slot-scope="props">
          {{ props.row.id }}
          <button v-if="$store.state.currentTemplateName !== 'global'" class="btn btn-danger float-right" @click="setEditRow(props.row)">Edit</button>
          <button v-else class="btn btn-secondary float-right" @click="setEditRow(props.row)">View</button>
        </template>

        <template slot="model" slot-scope="props">
          <span>{{ props.row.model }}</span>
        </template>

        <template slot="value" slot-scope="props">
          <span>{{ props.row.value }}</span>
        </template>

        <template slot="type" slot-scope="props">
          <span>{{ props.row.type }}</span>
        </template>
      </v-client-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modal-template-editor',

  data () {
    return {
      showDialog: false,
      currentTemplateName: '',

      columns: ['page', 'id', 'model', 'value', 'type'],
      options: {
        highlightMatches: true
      }
    }
  },

  mounted () {
    let that = this
    this.$bus.on('showTemplateEditorDialog', function () {
      that.currentTemplateName = that.$store.state.currentTemplateName
      that.showDialog = true
    })
    this.$bus.on('setCurrentTemplateName', function (templateName) {
      that.currentTemplateName = templateName
    })
    this.$bus.on('closeModal', function () {
      that.closeModal()
    })
  },

  methods: {
    setEditRow (rowData) {
      const fieldData = this.$store.getters.templateField(this.currentTemplateName, rowData.id, rowData.page)

      if (rowData.page !== this.$store.state.fileCurrentPage) {
        this.$store.commit('setCurrentPage', rowData.page)
        this.$bus.emit('pageChange', rowData.page)
      }

      this.$bus.emit('openFieldMenu', {
        id: fieldData.id,
        pos: { x: fieldData.x, y: fieldData.y },
        tabOrder: fieldData.tabOrder
      })
      this.closeModal()
    },

    closeModal () {
      this.$store.commit('setShowBottomMenu', true)
      this.showDialog = false
    },

    changeTemplate () {
      this.$store.commit('setCurrentTemplateName', this.currentTemplateName)
      this.$bus.emit('setCurrentTemplateName', this.currentTemplateName)
      let that = this
      this.$store.dispatch('applyTemplate').then(function (result) {
        if (result) {
          that.$bus.emit('addNotification', {
            title: 'Applied Template',
            body: 'Template "' + that.currentTemplateName + '" applied successfully.',
            type: 'success'
          })
        } else {
          that.$bus.emit('addNotification', {
            title: 'Error Applying Template',
            body: 'An error occured while applying the template "' + that.currentTemplateName + '". Please review the data and try again.',
            type: 'error'
          })
        }
      })
    }
  },

  beforeDestroy () {
    this.$bus.$off('showTemplateEditorDialog')
    this.$bus.$off('setCurrentTemplateName')
    this.$bus.$off('closeModal')
  }
}
</script>

<style lang="scss" scoped>

  .glyphicon-chevron-down::before {
    content: "\f362";
}
  .fas, .glyphicon {
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    display: inline-block;
    font-style: normal;
    font-variant: normal;
    text-rendering: auto;
    line-height: 1;
  }

  .modal-dialog {
    user-select: none;
    position: fixed;
    z-index: 100;
    top: 4%;
    left: 50%;
    margin-left: -45%;
    width: 90%;
    height: 91%;
    border: 1px solid black;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: #FFF;
    overflow: hidden;

    hr {
      border-top: 1px solid #777 !important;
    }

    .modalHeader {
      background-color: #2d5f8b;
      color: white;
      font-size: 18px;
      padding: 5px 10px 5px 10px;

      .btn-close {
        cursor: pointer;
        color: #FFF;
      }
    }

    .modalBody {
      padding: 10px;
      overflow-x: hidden;
      overflow-y: auto;
      height: 100%;
    }

    .btnSave {
      margin-right: 15px;
    }

    .btnUpload {
      position: absolute;
      top: 0;
      left: 300px;
    }
  }
  .myDialogM{
    pointer-events: auto;
    max-width: initial;
    overflow: auto;
  }

  // @import url("//netdna.bootstrapcdn.com/bootstrap/3.0.0/css/bootstrap-glyphicons.css");
  // @import url("@~/css/bootstrap-glyphicons");
</style>





// WEBPACK FOOTER //
// src/components/editor/modals/ModalTemplateEditor.vue